import { React, useEffect, useRef, useState } from 'react';
import { Row, Col, Button, Space, message, Form, Tag } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, } from 'react-router-dom'
import { default as ProTableOT } from "../../../../utility/ProTable_ot";
import SystemHolidayModal from './SystemHolidayModal';
import { PlusOutlined } from "@ant-design/icons";
import { useSystemHoliday } from '../Controller/useSystemHolidayController';


const SystemHolidayOverView = () => {
    const navigate = useNavigate();
    const actionRef = useRef()
    const [extra_columns, set_extra_columns] = useState([]);
    const [loading, set_loading] = useState(0);
    const [pageSize, setPageSize] = useState(20)
    const [columns, setColumns] = useState([
        {
            title: '年度',
            key: 'holiday_setting_year',
            dataIndex: 'holiday_setting_year',
            align: 'center',
            sorter: false,
        },
        {
            title: '放假日',
            key: 'all_holiday_count',
            dataIndex: 'all_holiday_count',
            sorter: false,
            align: 'center',
            render: (text, record, index) => {
                return (
                    <>
                        {text ?? 0}/365
                    </>
                )
            }
        },
        {
            title: '詳情',
            key: 'option',
            dataIndex: 'option',
            align: 'center',
            sorter: false,
            disabled: true,
            render: (text, record, index) => {
                return <>
                    {/* <Button
                        onClick={() => {
                            deleteSystemHolidaySettingData([
                                {
                                    holiday_setting_id: record?.holiday_setting_id
                                }
                            ])
                        }}
                    >
                        刪除
                    </Button> */}
                    <Button
                        type="primary"
                        onClick={() => {
                            navigate(`/cramSchool/admin/SystemHolidayDetailOverView/${record?.holiday_setting_id}`)
                        }}
                    >
                        詳細
                    </Button>
                </>
            }
        }
    ]);

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [axiosMode, setAxiosMode] = useState("get")
    const reload = () => {
        actionRef.current.reloadAndRest();
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                getSystemHolidaySettingNewYear()
                reload()
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                reload()
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                reload()
                // setSelectedRowsInfo([])
            }
            else if (axiosMode === "get") {
                set_loading(false)
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                reload()
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                reload()
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const newSystemHolidaySetting = () => {
        let lastYear = dayjs().subtract(1, 'year').format("YYYY")
        console.log(lastYear)
        if (!!systemHolidaySettingNewYearDatas?.year) {
            if (systemHolidaySettingNewYearDatas?.year < 2000) {
                postSystemHolidaySettingData(
                    [
                        {
                            year: lastYear
                        }
                    ]
                )
            }
            else {
                postSystemHolidaySettingData(
                    [
                        {
                            year:  systemHolidaySettingNewYearDatas?.year
                        }
                    ]
                )
            }
        }
    }
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    const {
        systemHolidaySettingNewYearDatas,
        getSystemHolidaySettingNewYear,
        getSystemHolidaySettingData,
        postSystemHolidaySettingData,
        deleteSystemHolidaySettingData
    } = useSystemHoliday({
        onBefore: () => { },
        onFinish: onFinish
    })
    useEffect(() => {
        getSystemHolidaySettingNewYear()
        checkAll()
    }, []);
    return (
        <Row gutter={[8, 8]}>
            <SystemHolidayModal
                propsLoading={modalLoading}
                open={modalOpen}
                setOpen={setModalOpen}
                onOk={() => {
                    newSystemHolidaySetting()
                }}
                data={{
                    ...systemHolidaySettingNewYearDatas
                }}
            />
            <Col span={24}>
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <ProTableOT
                            actionRef={actionRef}
                            columns={columns}
                            check={check}
                            setCheck={setCheck}
                            rowKey={'holiday_setting_id'}
                            selections={{
                                // onChange: (index_, data_) => set_data(data_)
                            }}
                            toolBarRender={() => [
                                <Button
                                    icon={<PlusOutlined />}
                                    style={{
                                        background: '#FdF9C9',
                                        display: "inline-flex",
                                        alignItems: "center"
                                    }}
                                    onClick={() => setModalOpen(true)}>
                                    新增年份
                                </Button>
                            ]}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            manage_columns={false}
                            request={async (params = {}, sort, filter) => {
                                setAxiosMode("get")
                                let newParams = {
                                };
                                let order = setOrders(sort)
                                newParams = {
                                    ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                    ...newParams,
                                    order,
                                    size: params.pageSize,
                                    cur_page: params.current,
                                    custom_filter_value: params.keyword ?? "",
                                    custom_filter_key: custom_filter_key
                                };
                                newParams = setParamsFilter({
                                    ...newParams,
                                });
                                setPageSize(params?.pageSize ?? 20)
                                return getSystemHolidaySettingData(newParams)
                            }}
                            pageSize={pageSize}
                            scroll={{
                                x: "max-content"
                            }}
                            rowSelection={false}
                        />
                    </Col>
                </Row>
            </Col>

        </Row>
    )
}
const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: 'DESC'
                })
            }
            else {
                return JSON.stringify({
                    column: key,
                    type: 'ASC'
                })
            }

        })
        return newOrders
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
export default SystemHolidayOverView;